module.exports = __webpack_public_path__ + "img/sv80.0cce6f86.svg";